"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ords = void 0;
const rds_1 = require("./rds");
class Ords {
    constructor(config) {
        this.rds = new rds_1.Rds();
        if (config) {
            this.rds.config(config);
        }
    }
    addConfigs(config) {
        this.rds.config(config);
    }
    use(name) {
        return this.rds.getObjectContainer().findPretty(name).instanceController();
    }
    hold() {
        this.rds.holdExternally();
    }
    continue() {
        this.rds.continueExternally();
    }
}
exports.Ords = Ords;
